// extracted by mini-css-extract-plugin
module.exports = {"blockTextBackground":"BlockTextBackground-module--blockTextBackground--2uHKd"};